import { render, staticRenderFns } from "./view-failure-records.vue?vue&type=template&id=68623aad&scoped=true"
import script from "./view-failure-records.vue?vue&type=script&lang=js"
export * from "./view-failure-records.vue?vue&type=script&lang=js"
import style0 from "./view-failure-records.vue?vue&type=style&index=0&id=68623aad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68623aad",
  null
  
)

export default component.exports